import { InterviewAgentType } from "@repo/app-types/entities/project";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { SimpleSelect } from "@repo/ui/Select/simpleSelect";
import type { FC } from "react";

interface InterviewAgentTypeSettingProps {
  interviewAgentType: InterviewAgentType | null;
  onChange: (newInterviewAgentType: InterviewAgentType) => void;
}

const options = [
  {
    label: "Standard (best for most use cases)",
    value: InterviewAgentType.GenericInterviewer,
  },
  {
    label: "Recruiting (best for candidate interviews)",
    value: InterviewAgentType.RecruitingInterviewer,
  },
];

export const InterviewAgentTypeSetting: FC<InterviewAgentTypeSettingProps> = ({
  interviewAgentType,
  onChange,
}) => {
  return (
    <div>
      <Label size={Size.SMALL}>Interview type</Label>
      <div className="mt-2 w-[350px]">
        <SimpleSelect
          value={interviewAgentType}
          onChange={onChange}
          options={options}
        />
      </div>
      <div className="mt-2 text-sm text-muted-foreground">
        The type of interview being conducted. The AI interviewer tone and style
        will be adapted to the interview type.
      </div>
    </div>
  );
};
